function composeEventHandlersUtil(...eventHandlers) {
    return (event)=>{
        eventHandlers.forEach((handler)=>{
            if (typeof handler === 'function' && !event.isDefaultPrevented()) {
                handler(event);
            }
        });
    };
}

export { composeEventHandlersUtil };
